import { Pencil, Trash } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./Button";
import axios from "axios";

const FacultyView = ({ title, data }) => {
  console.log(data);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  // Filter data based on the search query
  const filteredData = data?.filter((section) =>
    (typeof section === "string" ? section : section.toString()).includes(
      searchQuery
    )
  );

  // Handler for delete button
  const handleDelete = async (id) => {
    if (
      window.confirm(`Are you sure you want to delete ${title} with ID: ${id}?`)
    ) {
      axios.defaults.withCredentials = true;
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/delete-user`,
        { userID: id, type: "faculty" }
      );
      if (response.status === 200) {
        alert("Faculty deleted successfully!");
        window.location.reload();
      } else {
        alert("Failed to delete course!");
      }
    }
  };

  return (
    <div className="mb-12">
      {/* Search Bar */}
      <div className="mb-4 flex justify-between items-center">
        <h2 className="text-xl font-semibold ml-5">{title}</h2>
        <input
          type="text"
          placeholder="Search by ID"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Table */}
      <table className="min-w-full bg-white border border-gray-200 shadow-lg rounded-lg">
        <thead className="bg-gray-100">
          <tr>
            <th className="py-2 px-6 text-center">ID</th>
            <th className="py-2 px-6 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData?.length > 0 ? (
            filteredData?.map((section) => (
              <tr key={section._id} className="hover:bg-gray-50">
                <td className="py-2 px-6 border-b border-gray-200 leading-tight text-center">
                  {section._id}
                </td>
                <td className="py-2 px-6 border-b border-gray-200 text-center leading-tight">
                  <div className="flex justify-center space-x-3">
                    <Button
                      label="Edit"
                      Icon={Pencil}
                      color="bg-green-500"
                      hoverColor="hover:bg-green-600"
                      onClick={() => {
                        navigate(
                          `/admin/${title.toLowerCase()}/edit/${section._id}`
                        );
                      }}
                    />
                    <Button
                      label="Delete"
                      Icon={Trash}
                      color="bg-red-500"
                      hoverColor="hover:bg-red-600"
                      onClick={() => handleDelete(section._id)}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="2"
                className="py-4 text-center text-gray-500 border-b border-gray-200"
              >
                No matching results found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FacultyView;
